<template>
  <div class="Com_view">
    <div class="box_header">
      <!-- <el-image :src="require('../assets/image/bg_1.jpg')"></el-image> -->
    </div>
    <div class="box_section">
      <div class="box">
        <div class="box_title">
          <span class="title">关于我们 / About Us</span>
        </div>
        <div class="box_content">
          <span>广州市鸿年科技有限公司成立于1998年，经过20多年的发展，是国内从事医疗康复产品研发、开发、生产及销售的专业医疗技术公司。总部及研发生产基地位于广州市黄埔区国家级产业园区西陇创新园内。公司面积2400多平方米，目前拥有一批专业产品研发生产技术人员以及遍布全国的市场营销队伍，向顾客提供快捷高效的服务！ 公司成立以来，始终坚持以人才为本、诚信立业经营原则，荟萃业界精英，将国外先进技术、管理方法与企业自身实际相结合，提高企业管理水平和生产水平，使企业在激烈的市场竞争中始终坚持竞争力，实现企业快速、稳定地发展。</span>
          <span>我公司主要从事一类医疗器械压力绷带、二类医疗器械静脉曲张袜的生产，我们重视产品质量，公司坚持“质量第一、用户至上、以质兴业、以优取胜”的经营宗旨，关心行业健康发展，热心公益慈善事业，公司在中国整形美容行业及烧伤领域具有举足轻重的作用和地位。</span>
          <span>真诚携手，共赢同享，广州市鸿年科技有限公司愿与您携手共进，开创未来、实现梦想。</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  created() { },
  methods: {},
  mounted() { }
};
</script>

<style lang="less" scoped>
@media all and (max-width: 768px) {
  .Com_view {
    .box_section {
      padding: 20px 10% !important;
    }
  }
}
</style>

<style lang="less" scoped>
.Com_view {
  .box_header {
    height: 30vw;
    min-height: 200px;
    background-image: url('../assets/image/bg_3.jpg');
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }

  .box_section {
    margin: 40px 0 20px;
    padding: 20px 15%;
    border-bottom: 1px dashed #DCDCDA;

    .box {
      margin-bottom: 40px;
    }

    .box_title {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        color: #4e346e;
        font-size: 20px;
        position: relative;

        &::before {
          position: absolute;
          left: 0;
          bottom: -5px;
          border-radius: 5px;
          content: "";
          width: 80px;
          height: 2px;
          background: linear-gradient(to bottom, #cbabf1, #4e346e);
        }
      }


    }

    .box_content {
      font-size: 14px;
      line-height: 25px;

      span {
        display: block;
        margin-top: 20px;
      }
    }

  }
}
</style>